import './Payments.css';

const Payments = () => {
    return (
        <div className="payments">
          <p>
The Microsoft CMT service was used for managing the peer-reviewing process for this conference. This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.
</p>
        </div>
    );
};

export default Payments;